import type { AdminUserWithClaims } from "@hellocashflow/domain";

export interface AdminAccessAuditSummary {
  total: number;
  verified: number;
  disabled: number;
}

export const formatDateTime = (value?: string | null): string => {
  if (!value) {
    return "Not available";
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "Invalid date";
  }

  return date.toLocaleString();
};

export const buildAdminAccessAuditSummary = (
  adminUsers: readonly AdminUserWithClaims[],
): AdminAccessAuditSummary => {
  if (!adminUsers.length) {
    return {
      total: 0,
      verified: 0,
      disabled: 0,
    };
  }

  const verified = adminUsers.filter(
    (user) => user.firebaseUser.emailVerified,
  ).length;
  const disabled = adminUsers.filter(
    (user) => user.firebaseUser.disabled,
  ).length;

  return {
    total: adminUsers.length,
    verified,
    disabled,
  };
};
